import { render, staticRenderFns } from "./ImportantClient.vue?vue&type=template&id=f9b64b32&scoped=true"
import script from "./ImportantClient.vue?vue&type=script&lang=js"
export * from "./ImportantClient.vue?vue&type=script&lang=js"
import style0 from "./ImportantClient.vue?vue&type=style&index=0&id=f9b64b32&prod&scoped=true&lang=less"
import style1 from "./ImportantClient.vue?vue&type=style&index=1&id=f9b64b32&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b64b32",
  null
  
)

export default component.exports